// Sadly, there are no modern type definitions for NanoEvents 2. :(
// @ts-ignore
import NanoEvents from 'nanoevents';
import { isBrowser } from "@montana/helpers/browser.helper";

let resizeEventBound = false;
let allowPublish = true;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const resizeEmitter = new NanoEvents<any>();

export interface IWindowSize {
    width: number;
    height: number;
    angle: number;
    orientation: string;
}


export const getWindowSize = (): IWindowSize => ({
    width: window.innerWidth,
    height: window.innerHeight,
    angle: (window && window.screen && window.screen.orientation && window.screen.orientation.angle) || 0,
    orientation: (window && window.screen && window.screen.orientation && window.screen.orientation.type) || "",
});


const bindGlobalResizeEvent = (): void => {
    if (!resizeEventBound) {

        const callback = (): void => {
            if (allowPublish) {
                resizeEmitter.emit("resize", getWindowSize());
            }
        };

        if (isBrowser) {
            window.addEventListener("resize", callback);
            window.addEventListener("orientationchange", callback);
        }

        resizeEventBound = true;
    }
};



// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const onResize = (funcRef: (props: IWindowSize) => any): Function => {
    bindGlobalResizeEvent();
    return resizeEmitter.on("resize", funcRef);
};


export const disableResizeCallback = (): void => {
    allowPublish = false;
};

export const enableResizeCallback = (): void => {
    allowPublish = true;
};

